import { Table } from '@tiptap/extension-table'
import { TableCell } from '@tiptap/extension-table-cell'
import { TableHeader } from '@tiptap/extension-table-header'
import { TableRow } from '@tiptap/extension-table-row'

/**
 * Розширення пресета «description» понад StarterKit: таблиці (Q2.8,
 * `SPEC-025` §3.6.1). Роздільник (`HorizontalRule`) уже входить у StarterKit.
 *
 * Одні й ті самі в редакторі (`RichTextInput`) і в показі (`RichTextView`):
 * схема показу без них мовчки викинула б таблицю з картки.
 *
 * Ширину стовпців мишею не тягнемо (`resizable: false`): HTML лишається
 * рівно тим, що пропускає бек (`RichTextSanitizer::sanitizeWithTables()`).
 */
export const TABLE_EXTENSIONS = [Table.configure({ resizable: false }), TableRow, TableHeader, TableCell]
